'use strict';

module Patersons {
    export class Investor {
        id: number;
        userId: number;
        accoladeOptions: AccoladeOptions;
        subscriptions: ResearchSubscription[];
    }
    export class AccoladeOptions {
        id: number;
        userId: number;
        hasElectronicQuarterlyReports: boolean;
        hasElectronicTaxReports: boolean;
    } 
    export class ResearchSubscription {
        name: string;
        id: string;
        isSubscribed: boolean;
        updatedAt: Date;
    } 

}